import { clsx } from "clsx";
import styles from "./FullscreenLayout.module.css";

export const FullscreenLayout = ({
  children,
  footer,
  className,
}: {
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={clsx(styles.layout, className)}>
      <div>{children}</div>
      <ExpandingDiv />
      {footer}
    </div>
  );
};

const ExpandingDiv = () => <div />;
